import { render, staticRenderFns } from "./ItemTile.vue?vue&type=template&id=477462e8&scoped=true&"
import script from "./ItemTile.vue?vue&type=script&lang=js&"
export * from "./ItemTile.vue?vue&type=script&lang=js&"
import style0 from "./ItemTile.vue?vue&type=style&index=0&id=477462e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "477462e8",
  null
  
)

export default component.exports